import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, useIntl} from "react-intl";

import {Box} from "@mui/material";

import CategoryBarChart from "./components/CategoryBarChart";
import MobileCarousel from "components/MobileCarousel";

import {UserAgentUtils} from "utils/useragent";

CategoriesBarChart.propTypes = {
    loading : PropTypes.bool,
    categories: PropTypes.array,
    totalAlerts: PropTypes.number,
    currency: PropTypes.string,
};

function translateOtherCategoryName(categories) {
    const intl = useIntl();

    if (!categories || !categories.length) {
        return [];
    }

    return categories.map((category) => {
        if (category?.name === "other") {
            return {
                ...category,
                name: intl.formatMessage({id: "dashboard.stockAlerts.chart.byCategory.otherCategory"})
            }
        }

        return category;
    })
}

function CategoriesBarChart({loading, categories, totalAlerts = 0, currency, ...props}) {
    const intl = useIntl();

    categories = translateOtherCategoryName(categories);

    return (
        <Box sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            mb: 3
        }}>
            {UserAgentUtils.isMobile() ? (
                <MobileCarousel>
                    <CategoryBarChart
                        title={<FormattedMessage id="dashboard.stockAlerts.chart.byCategory"/>}
                        subtitle={intl.formatMessage({id: "dashboard.stockAlerts.chart.byCategory.subtitle"}, {count: totalAlerts})}
                        categories={categories}
                        valueKey="alertCount"
                        loading={loading}
                    />
                    <CategoryBarChart
                        title={<FormattedMessage id="dashboard.stockAlerts.chart.caPerduByCategory"/>}
                        subtitle={intl.formatMessage({id: "dashboard.stockAlerts.chart.caPerduByCategory.subtitle"})}
                        categories={categories}
                        valueKey="lostRevenue"
                        loading={loading}
                        formatValue={v => intl.formatNumber(v, {
                            style: "currency",
                            currency: currency ?? "EUR",
                            maximumFractionDigits: 2
                        })}
                    />
                </MobileCarousel>
            ) : (
                <>
                    <CategoryBarChart
                        title={<FormattedMessage id="dashboard.stockAlerts.chart.byCategory"/>}
                        subtitle={intl.formatMessage({id: "dashboard.stockAlerts.chart.byCategory.subtitle"}, {count: totalAlerts})}
                        categories={categories}
                        valueKey="alertCount"
                        loading={loading}
                    />
                    <CategoryBarChart
                        title={<FormattedMessage id="dashboard.stockAlerts.chart.caPerduByCategory"/>}
                        subtitle={intl.formatMessage({id: "dashboard.stockAlerts.chart.caPerduByCategory.subtitle"})}
                        categories={categories}
                        valueKey="lostRevenue"
                        loading={loading}
                        formatValue={v => intl.formatNumber(v, {
                            style: "currency",
                            currency: currency ?? "EUR",
                            maximumFractionDigits: 2
                        })}
                    />
                </>
            )}
        </Box>
    );
}

export default CategoriesBarChart;
